module.exports = __webpack_public_path__ + "assets/img/two.aff207bf.png";